import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { setCashout } from 'services/withDraw'
import posthog from 'posthog-js'
import useFinishFlow, { FLOWS } from 'utilities/navigation/flow'
import { apiMessage } from 'modules/cashbox/ui'

export default function useSetCashouts() {
    const finishFlow = useFinishFlow(FLOWS.cashout)
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IGetCardsPayloadFinal) => {
            return setCashout(payload)
        },
        onSuccess: (data, variables, payload) => {
            toast.success('برداشت با موفقیت ثبت شد')
            posthog.capture('fund_withdrawal_succeeded', {
                method: 'manual_record',
                amount: (variables as any)?.amount,
                reason: (variables as any)?.reason,
                moneypool_id: (variables as any)?.moneyPool,
                // what joins the member's درخواست برداشت to the payout that
                // answered it; absent on an ordinary cash-out
                withdrawal_request: (variables as any)?.withdrawal_request,
            })
            finishFlow('/funds')
        },
        onError: (error: any, variables) => {
            posthog.capture('fund_withdrawal_failed', {
                method: 'manual_record',
                status: error?.response?.status,
                withdrawal_request: (variables as any)?.withdrawal_request,
            })
            // The backend refuses with a sentence the manager can act on —
            // «مبلغ از باقیماندهٔ درخواست بیشتر است.», «شماره کارت یا حساب
            // مقصد را انتخاب کنید.» — and «خطایی رخ داده!» threw it away. On
            // 2026-09-17 a manager tried the same 14.5M withdrawal twice
            // against a 3M request and never learned why it would not go.
            toast.error(apiMessage(error, 'خطایی رخ داده!'))
        },
    })

    return { isLoading, mutate }
}
